import { useEffect, useState } from "react";
import styles from "../../../propertydetails.module.css";
import { useAuth0 } from "@auth0/auth0-react";
import Loader from "../../../../../components/Loader";
import { Controller, useForm } from "react-hook-form";
import { Accordion, AccordionDetails, AccordionSummary, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from "@mui/material";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import NumberFormat from "react-number-format";
import axios from "axios";
import { AddLogCallAPI } from "../../../../../components/AddLogs";
import { toast } from "react-smart-toaster";
import { Eye, EyeOff, X } from "react-feather";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PropertyTaskList from "./components/PropertyTaskList";
import PropertyKeyFobs from "./components/PropertyKeyFobs";
import EmailSettings from "./components/EmailSettings";
import LateFeeSettings from "./components/LateFeeSettings";
import NSFFeeSettings from "./components/NSFFeeSettings";
import ProspectApprovalSettings from "./components/ProspectApprovalSettings";
import PropertyTwilioNumber from "./components/PropertyTwilioNumber";
import smartdeviceServices from "../../../../smartdevices/smartdevice.services";
import PropertyParkingGateCommand from "./components/PropertyParkingGateCommand";

function TenDigitField(props) {
  return (<NumberFormat customInput={TextField} prefix="" displayType="input" type="text" thousandSeparator={false} decimalScale={0} {...props} />);
}

function TenDigitDecimalField(props) {
  return (<NumberFormat customInput={TextField} prefix="" displayType="input" type="text" thousandSeparator={false} {...props} />);
}

const passcodeRegExp = /^\d{6,}$/;
const schema2 = yup.object().shape({
  doorlock_password: yup.string().required("This field is Required").matches(passcodeRegExp, { message: "Please enter minimum 6 digit passcode", excludeEmptyString: true })
});



const schema3 = yup.object().shape({
  min_credit_score: yup.string().required("This field is Required").max(3, "This field can not be more than 3 digits.").test("non-zero-validate", "This field should be 1 or greater.", (value) => parseInt(value) > 0),
  min_income_multiplier: yup.string().required("This field is Required").test("non-zero-validate", "This field should be 1 or greater.", (value) => parseInt(value) > 0)
});

const PaymentSetTab = (props) => {
  const { getAccessTokenSilently, isAuthenticated, user } = useAuth0();
  const [loading, setLoading] = useState(false);
  const [lockViewType, setLockViewType] = useState("password");
  const [isPasscode, setIsPasscode] = useState(0);
  const [oldPasscode, setOldPasscode] = useState('');
  const [showSuccessMsg, setShowSuccessMsg] = useState(false);
  const [successMsg, setSuccessMsg] = useState('');

  const { handleSubmit: handleSubmit2, control: control2, errors: errors2, setValue: setValue2 } = useForm({
    shouldUnregister: false,
    resolver: yupResolver(schema2),
  });

  const { handleSubmit: handleSubmit3, control: control3, errors: errors3, setValue: setValue3 } = useForm({
    shouldUnregister: false,
    resolver: yupResolver(schema3),
  });

  useEffect(() => {
    if (props?.doorlock_password && props?.doorlock_password !== "") {
      setIsPasscode(1);
      setValue2("doorlock_password", props?.doorlock_password);
      setOldPasscode(props?.doorlock_password);
    }

    if (props?.prospect_criteria) {
      setValue3("min_credit_score", props?.prospect_criteria?.min_credit_score);
      setValue3("min_income_multiplier", props?.prospect_criteria?.min_income_multiplier);
    }
  }, [props?.doorlock_password, props?.prospect_criteria, setValue2, setValue3]);

  const onSubmit2 = async (data) => {
    let oldPasscodeTemp = oldPasscode;
    let newPasscodeTemp = data?.doorlock_password;
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
    setLoading(true);
    return axios.put(process.env.REACT_APP_PROPERTY_API_URL + "v1/properties/" + props?.property_id + "/update-lock-password", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      //setLoading(false);

      //props.setSnackbarMsg(response.data.message);
      //props.setSnackbarOpen(true);

      props.setPropertyData((prev) => {
        return { ...prev, doorlock_password: response.data?.data?.doorlock_password };
      });

      let logData = {
        title: "Door lock passcode is updated",
        description: ["Property: " + props?.property_name],
      };
      AddLogCallAPI(logData, token);

      updateMasterPin(props?.property_id, oldPasscodeTemp, newPasscodeTemp, 0);

      /*axios.post(process.env.REACT_APP_DEVICE_API_URL + "v1/ttlock/update-all-passcode-new/" + props?.property_id, { 'oldPasscode': oldPasscodeTemp, 'newPasscode': newPasscodeTemp }, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }).then((response) => {
        setLoading(false);
        let resData = response.data;
        let sucMsg = '';

        if (resData.failedDevices.length > 0) {
          sucMsg = '<p>Your new master password synced to <strong>' + (resData?.totalDevices.length - resData?.failedDevices.length) + ' of ' + resData?.totalDevices.length + ' locks</strong>.The remaining locks are still using <strong> old password</strong>.</p><div><strong>Failed Locks:</strong></div><div><ol>';
          for (let n in resData?.failedDevices) {
            sucMsg += '<li>' + resData?.failedDevices[n] + '</li>';
          }
          sucMsg += '</ol></div>';
        } else {
          sucMsg = '<p>Your new master password has been successfully synced to all <strong>' + resData?.totalDevices.length + ' locks</strong>.</p>';
        }
        setSuccessMsg(sucMsg);
        setShowSuccessMsg(true);
      }).catch((error) => {
        if (typeof error.response !== "undefined")
          toast.error(error.response.data.message);
        setLoading(false);
      });*/
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  };

  const updateMasterPin = async (propertyId, oldPasscode, newPasscode, page, totalDevices = 0, currentDevices = 0, failedDevices = []) => {
    try {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

      let res = await smartdeviceServices.updateAllPasscodes(token, propertyId, { 'oldPasscode': oldPasscode, 'newPasscode': newPasscode, page: page });

      if (res.status === 200) {
        totalDevices = res.data.totalDevices;
        currentDevices += res.data.deviceList.length;
        failedDevices = failedDevices.concat(res.data.failedDevices);

        if (currentDevices < totalDevices) {
          updateMasterPin(propertyId, oldPasscode, newPasscode, page + 1, totalDevices, currentDevices, failedDevices);
        } else {
          setLoading(false);

          let sucMsg = '';

          if (failedDevices.length > 0) {
            sucMsg = '<p>Your new master password synced to <strong>' + (currentDevices - failedDevices.length) + ' of ' + currentDevices + ' locks</strong>.The remaining locks are still using <strong> old password</strong>.</p><div><strong>Failed Locks:</strong></div><div><ol>';
            for (let n in failedDevices) {
              sucMsg += '<li>' + failedDevices[n] + '</li>';
            }
            sucMsg += '</ol></div>';
          } else {
            sucMsg = '<p>Your new master password has been successfully synced to all <strong>' + currentDevices + ' locks</strong>.</p>';
          }
          setSuccessMsg(sucMsg);
          setShowSuccessMsg(true);
        }
      } else {
        setLoading(false);
        toast.error('Server is not responing. Try again.');
      }
    } catch (error) {
      setLoading(false);
      console.log('error');
      console.log(error);
      toast.error('Server is not responing. Try again.');
    }
  }

  const [expanded, setExpanded] = useState("");
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const onSubmit3 = async (data) => {
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
    setLoading(true);
    return axios.put(process.env.REACT_APP_PROPERTY_API_URL + "v1/properties/" + props?.property_id + "/update-prospect-criteria", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setLoading(false);

      props.setSnackbarMsg(response.data.message);
      props.setSnackbarOpen(true);

      props.setPropertyData((prev) => {
        return { ...prev, min_credit_score: response.data?.data?.min_credit_score, min_income_multiplier: response.data?.data?.min_income_multiplier };
      });

      let logData = {
        title: "Prespect screening criteria is updated",
        description: ["Property: " + props?.property_name],
      };
      AddLogCallAPI(logData, token);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  const latefeeUpdate = async (data) => {
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
    props.setSnackbarMsg(data?.message);
    props.setSnackbarOpen(true);

    props.setPropertyData((prev) => {
      return { ...prev, is_auto_late_fee: data?.data?.is_auto_late_fee, grace_period: data?.data?.grace_period, type_of_fee: data?.data?.type_of_fee, fee_amount: data?.data?.fee_amount };
    });

    let logData = {
      title: "Payment settings are updated",
      description: ["Property: " + props?.property_name],
    };
    AddLogCallAPI(logData, token);
  }

  const NSFFeeUpdate = async (data) => {
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
    props.setSnackbarMsg(data?.message);
    props.setSnackbarOpen(true);

    props.setPropertyData((prev) => {
      return { ...prev, nsf_fee: data?.data?.nsf_fee };
    });

    let logData = {
      title: "Payment settings are updated",
      description: ["Property: " + props?.property_name],
    };
    AddLogCallAPI(logData, token);
  }

  return (<>
    {loading && <Loader />}

    <div className={`${styles.SettingsTabSec} SettingsTabSec`}>
      <Accordion expanded={expanded === "panel1"} onChange={handleChange("panel1")}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1-content" id="panel1-header">
          <h5 className={`${styles.SettingsTitle}`}>Email Notifications</h5>
        </AccordionSummary>
        <AccordionDetails>
          <EmailSettings
            property_id={props?.property_id}
            setLoading={setLoading.bind(this)}
            setSnackbarMsg={props.setSnackbarMsg.bind(this)}
            setSnackbarOpen={props.setSnackbarOpen.bind(this)}
            setPropertyData={props.setPropertyData.bind(this)}
            property_emails={props?.property_emails}
          />
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded === "panel2"} onChange={handleChange("panel2")}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2-content" id="panel2-header">
          <h5 className={`${styles.SettingsTitle}`}>Late Fee Settings</h5>
        </AccordionSummary>
        <AccordionDetails>
          <LateFeeSettings setLoading={setLoading.bind(this)} property_id={props?.property_id} late_fee_data={props?.late_fee_data} onUpdate={latefeeUpdate.bind(this)} />
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded === "panel21"} onChange={handleChange("panel21")}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel21-content" id="panel21-header">
          <h5 className={`${styles.SettingsTitle}`}>ACH Non-sufficient Fund (NSF) Fee Settings</h5>
        </AccordionSummary>
        <AccordionDetails>
          <NSFFeeSettings setLoading={setLoading.bind(this)} property_id={props?.property_id} nsf_fee={props?.nsf_fee} onUpdate={NSFFeeUpdate.bind(this)} />
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded === "panel3"} onChange={handleChange("panel3")}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel3-content" id="panel3-header">
          <h5 className={`${styles.SettingsTitle}`}>Master Passcode for Smart Door Lock</h5>
        </AccordionSummary>
        <AccordionDetails>
          <form onSubmit={handleSubmit2(onSubmit2)}>
            <div style={{ maxWidth: "300px" }}>
              <div className={`${styles.FormRow}`}>
                <div className={`${styles.FormGroupFullPay} FormGroup`}>
                  <Controller
                    name={`doorlock_password`}
                    control={control2}
                    render={(field) => (<NumberFormat
                      {...field}
                      customInput={TextField}
                      label="Master Password*"
                      id="outlined-basic"
                      variant="outlined"
                      prefix=""
                      displayType="input"
                      type={lockViewType}
                      thousandSeparator={false}
                      allowNegative={false}
                      decimalScale={0}
                      disabled={isPasscode === 1}
                    />)}
                  />
                  {lockViewType === "password" ? (<Eye onClick={(e) => setLockViewType("text")} className={`${styles.eyeIcon}`} />) : (<EyeOff onClick={(e) => setLockViewType("password")} className={`${styles.eyeIcon}`} />)}
                  {/* <button type="button" onClick={(e) => { setValue2('doorlock_password', ''); setIsPasscode(0); }}>Click to update</button> */}
                  {errors2.doorlock_password && (<p className={`${styles.ErrorM}`}>{errors2.doorlock_password.message}</p>)}
                </div>
              </div>

              {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("property-settings:update") > -1 && <div>
                {isPasscode === 0 && (<button type="submit" className={`${styles.ButtonVoiletSolid}`}>Update</button>)}
                {isPasscode === 1 && (<button type="button" onClick={(e) => { setValue2("doorlock_password", ""); setIsPasscode(0); }} className={`${styles.ButtonVoiletSolid}`}>Click to update</button>)}
              </div>}
            </div>
          </form>
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded === "panel4"} onChange={handleChange("panel4")}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel4-content" id="panel4-header">
          <h5 className={`${styles.SettingsTitle}`}>Master Keyfobs for Smart Door Lock</h5>
        </AccordionSummary>
        <AccordionDetails>
          <PropertyKeyFobs
            property_id={props?.property_id}
            property_name={props?.property_name}
            keyfobs={props?.keyfobs}
            setLoading={setLoading.bind(this)}
            setSnackbarMsg={props.setSnackbarMsg.bind(this)}
            setSnackbarOpen={props.setSnackbarOpen.bind(this)}
            setPropertyData={props.setPropertyData.bind(this)}
          />
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded === "panel5"} onChange={handleChange("panel5")}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel5-content" id="panel5-header">
          <h5 className={`${styles.SettingsTitle}`}>Prospect Screening Criteria</h5>
        </AccordionSummary>
        <AccordionDetails>
          <form onSubmit={handleSubmit3(onSubmit3)}>
            <div style={{ maxWidth: "300px" }}>
              <div className={`${styles.FormRow}`}>
                <div className={`${styles.FormGroupFullPay} FormGroup`}>
                  <Controller
                    name={`min_credit_score`}
                    control={control3}
                    render={(field) => (<TenDigitField
                      format="###"
                      value={field.value}
                      onChange={(e) => field.onChange(e)}
                      label="Minimum Credit Card"
                      variant="outlined"
                    />)}
                  />
                  {errors3.min_credit_score && (<p className={`${styles.ErrorM}`}>{errors3?.min_credit_score?.message}</p>)}
                </div>
              </div>
              <div className={`${styles.FormRow}`}>
                <div className={`${styles.FormGroupFullPay} FormGroup`}>
                  <Controller
                    name={`min_income_multiplier`}
                    control={control3}
                    render={(field) => (<TenDigitDecimalField
                      value={field.value}
                      onChange={(e) => field.onChange(e)}
                      label="Income Multiple"
                      variant="outlined"
                    />)}
                  />
                  {errors3.min_income_multiplier && (<p className={`${styles.ErrorM}`}>{errors3?.min_income_multiplier?.message}</p>)}
                </div>
              </div>

              {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("property-settings:update") > -1 && <div>
                <button type="submit" className={`${styles.ButtonVoiletSolid}`}>Update</button>
              </div>}
            </div>
          </form>
        </AccordionDetails>
      </Accordion>

      {/* Task list accordian */}
      <Accordion expanded={expanded === "panel6"} onChange={handleChange("panel6")}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel6-content" id="panel6-header">
          <h5 className={`${styles.SettingsTitle}`}>Prospect Tasklist</h5>
        </AccordionSummary>
        <AccordionDetails>
          <PropertyTaskList {...props} />
        </AccordionDetails>
      </Accordion>

      <Accordion expanded={expanded === "panel7"} onChange={handleChange("panel7")}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel7-content" id="panel7-header">
          <h5 className={`${styles.SettingsTitle}`}>Prospect Approval Settings</h5>
        </AccordionSummary>
        <AccordionDetails>
          <ProspectApprovalSettings approval_deadline_days={props?.approval_deadline_days} setLoading={setLoading.bind(this)} setSnackbarMsg={props.setSnackbarMsg.bind(this)} setSnackbarOpen={props.setSnackbarOpen.bind(this)} setPropertyData={props.setPropertyData.bind(this)} property_name={props.property_name} property_id={props.property_id} />
        </AccordionDetails>
      </Accordion>

      <Accordion expanded={expanded === "panel8"} onChange={handleChange("panel8")}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel8-content" id="panel8-header">
          <h5 className={`${styles.SettingsTitle}`}>Twilio Number For SMS Communication</h5>
        </AccordionSummary>
        <AccordionDetails>
          <PropertyTwilioNumber twilio_number={props?.twilio_number} setLoading={setLoading.bind(this)} setSnackbarMsg={props.setSnackbarMsg.bind(this)} setSnackbarOpen={props.setSnackbarOpen.bind(this)} setPropertyData={props.setPropertyData.bind(this)} property_name={props.property_name} property_id={props.property_id} />
        </AccordionDetails>
      </Accordion>

      <Accordion expanded={expanded === "panel9"} onChange={handleChange("panel9")}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel9-content" id="panel9-header">
          <h5 className={`${styles.SettingsTitle}`}>Parking Gate Unlock Cammand</h5>
        </AccordionSummary>
        <AccordionDetails>
          <PropertyParkingGateCommand parking_gate_command={props?.parking_gate_command} setLoading={setLoading.bind(this)} setSnackbarMsg={props.setSnackbarMsg.bind(this)} setSnackbarOpen={props.setSnackbarOpen.bind(this)} setPropertyData={props.setPropertyData.bind(this)} property_name={props.property_name} property_id={props.property_id} />
        </AccordionDetails>
      </Accordion>
    </div>

    <Dialog
      open={showSuccessMsg}
      fullWidth
      maxWidth="sm"
      onClose={(e) => setShowSuccessMsg(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp"
    >
      <DialogTitle id="alert-dialog-title">Sync Master Passcode<button onClick={(e) => setShowSuccessMsg(false)}><X /></button>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <div className="ModalFormGroup">
            <label className="PopupBodyText" style={{ fontSize: '16px' }} dangerouslySetInnerHTML={{ __html: successMsg }}></label>
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <button onClick={(e) => setShowSuccessMsg(false)} className="SubmitPopupBU" style={{ minWidth: '80px' }}>OK</button>
      </DialogActions>
    </Dialog>
  </>);
};

export default PaymentSetTab;